import MainPage from './views/Main/MainPage/MainPage';

function App() {
  return MainPage();
}

export default App;
